var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.75C5.16751 18.75 1.25 14.8325 1.25 10C1.25 5.16751 5.16751 1.25 10 1.25C14.8325 1.25 18.75 5.16751 18.75 10C18.75 14.8325 14.8325 18.75 10 18.75ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61929 12.5 7.5 11.3807 7.5 10C7.5 8.61929 8.61929 7.5 10 7.5C11.3807 7.5 12.5 8.61929 12.5 10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 5C7.2385 5 4.99992 7.23858 4.99992 10C4.99992 10.3452 4.7201 10.625 4.37492 10.625C4.02975 10.625 3.74992 10.3452 3.74992 10C3.74992 6.54822 6.54814 3.75 9.99992 3.75C10.3451 3.75 10.6249 4.02982 10.6249 4.375C10.6249 4.72018 10.3451 5 9.99992 5ZM15.6249 9.375C15.9701 9.375 16.2499 9.65482 16.2499 10C16.2499 13.4518 13.4517 16.25 9.99992 16.25C9.65475 16.25 9.37492 15.9702 9.37492 15.625C9.37492 15.2798 9.65475 15 9.99992 15C12.7613 15 14.9999 12.7614 14.9999 10C14.9999 9.65482 15.2797 9.375 15.6249 9.375Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.a3769c27e96f73d16b5cdefde7bb4fd6.svg";
export { ForwardRef as ReactComponent };